<div class="bar" [ngClass]="[type, class]">
  <ng-content select="img"></ng-content>
  <div class="text">
    <ng-content></ng-content>
  </div>
  <div class="button-container">
    <ng-content class="button" select="button"></ng-content>
  </div>
</div>
